import React, { useState } from "react";
import { Button } from "../../components";
import { content } from "../../data/mock";
import { Typography } from "antd";

const { Title } = Typography;

const ContentPreference = () => {
  const [tags, setTags] = useState([]);
  const onChangeTags = (tag) => {
    if (tags.indexOf(tag) > -1) {
      setTags(tags.filter((item) => item !== tag));
    } else {
      setTags((arr) => [...arr, tag]);
    }
  };
  return (
    <>
      <Title level={3}> Content Preference  </Title>
      <Title level={5}> Set your content preference by joining the various hashtags </Title>
      <div className="mt-10 mb-2 overflow-x-auto">
        {content.map((item,index) => (
          <Button
            key={index}
            onClick={() => onChangeTags(item.title)}
            type="primary"
            className={`${
              tags.indexOf(item.title) > -1 ? "selectedBtn" : `${item.type? "button-tetiary" : "button-quad"}`
            } mt-10 mr-5 primary-color`}
            title={item.title}
            style={{ height: "50px", borderRadius: "30px", width: "fit-content"}}
          />
        ))}
      </div>
      <div className="text-center mt-10">
        <p>Load More</p>
      </div>
    </>
  );
};

export default ContentPreference;
